import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
//import { ScrollSmoother } from "gsap/ScrollSmoother";
import { TextPlugin } from "gsap/TextPlugin";
import { GSDevTools } from "gsap/GSDevTools";
import { SplitText } from "gsap/SplitText";


class HeroSlider {
  constructor(el) {

    
    gsap.registerPlugin(SplitText)

let slideX = 0;
const slideshow = document.querySelector('.slideshow');
const slides = slideshow.querySelectorAll('.slide');

var master = gsap.timeline({})
const bloki = ["nadwoziaBlok","reklamaBlok","drukarniaBlok"  ];

function slideAnim() {

	let split
	var animation = gsap.timeline({ repeatRefresh: true, onComplete: updateVar})

	let slide = slides.item(slideX)
	let slideImage = slide.querySelector('.slide-image');
	let slideTitle = slide.querySelector('.slide-title');
	let blok = bloki[slideX];

	const element = document.getElementById(blok);
	const rect = element.getBoundingClientRect();
	const rectPositionX = rect.left;


	let blokElement = "#"+blok+" figure";
	animation.set(slide, {opacity:0, autoAlpha: 1});
	animation.set(slideImage, {filter: 'brightness(1)'});
	animation.set(slideTitle, {x:rectPositionX, autoAlpha: 1});
	animation.to(slide, {duration: 0.5, opacity: 1, display:"block", ease:"back.out(1.7)"});
	animation.fromTo(slideImage, {filter: 'brightness(1)'}, {duration: 0.5, filter: 'brightness(0.5)'}, '>+0.5');
	animation.to(blokElement, {scale: 1.2, duration: 1, y:-50, ease: 'back.out(1.7)'}, "-=1");
	
	split = new SplitText(slideTitle, {type:"chars"})
	animation.from(split.chars, {filter: "blur(10px)", opacity:0, y:150, ease:"back.out(1.7)", stagger:{
		from:"start", //try "center" and "edges"
		each:0.05
	}}, "<")
	animation.fromTo(slideImage, { filter: "blur(0px) brightness(0.5)" }, {filter: "blur(10px) brightness(0)", duration: 1, ease:"back.out(1.7)"}, ">+1.5");
	animation.fromTo(slide, { filter: "blur(0px)" }, {filter: "blur(10px)", duration: 1, autoAlpha: 0, display:"none", ease:"back.out(1.7)"}, "-=1.5");
	animation.to(blokElement, {scale: 1, duration: 1, y:-0, ease: 'back.out(1.7)'}, "-=1.5");
	return animation;

	
}
function updateVar() {
	slideX++;
	if (slideX == slides.length) {
		slideX = 0;
	}
	console.log("w Funkcji slideX: "+slideX);
	master.add(slideAnim(), ">");
}
master.add(slideAnim(), ">");

}

}

export default HeroSlider
